<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
  document.addEventListener("DOMContentLoaded", function () {
  const productOption = document.querySelector('.product-details .product-option');

  // Check if Variant Picker is visible
  const isVariantVisible = productOption && 
                           productOption.offsetWidth > 0 && 
                           productOption.offsetHeight > 0 && 
                           window.getComputedStyle(productOption).display !== "none" &&
                           window.getComputedStyle(productOption).visibility !== "hidden";

  // Create wrapper ONLY if the Variant Picker is visible
  if (isVariantVisible) {
    const wrapper = document.createElement('div');
    wrapper.className = 'product-flex-wrapper';

    // Insert wrapper before product option to maintain correct order
    productOption.parentNode.insertBefore(wrapper, productOption);
    
    // Append the visible Variant Picker inside wrapper
    wrapper.appendChild(productOption);
    
    // Check and append quantity if it exists
    const quantity = document.querySelector('.product-details .productView-quantity');
    if (quantity) wrapper.appendChild(quantity);
  }
});





